import React from "react";
import CustomerProductList from "../../components/event/CustomerProductList";

const CustomerProductsPage = () => {
    return <CustomerProductList/>
}

export default CustomerProductsPage;